import styled from 'styled-components';
import { motion } from "framer-motion";

export const UnitPreview = styled(motion.div)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f0f0f0;
  z-index: 1000;
  flex-direction: column;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
`;

export const ExpandIcon = styled.div`
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
`;

export const Column1 = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 0 60%;
    min-width: 60%;
    position: relative;
`;

export const Column2 = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 0 40%;
`;

export const SalePrice = styled.h2`
  font-size: 1.6em;
  text-align: left;
  margin: 0;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
  color: #424242;
`;

export const UnitPreviewText = styled.p`
  color: #424242;
  text-align: left;
  font-family: 'Roboto', sans-serif;
  margin: 3px 0;
  font-size: 0.8rem;
`;

export const Thumbnail = styled.img`
  width: 100%;
  border: 0;
  padding: 0;
`;

export const ContentArea = styled.div`
  padding: 15px;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

export const ScoreWrapper = styled.div`
  width: 100%;
  height: 40px;
`;

export const ScoreCircle = styled.div`
    width: 30px;
    height: 30px;
    float: left;
`;

export const ScoreText = styled.span`
  font-size: 1.6rem;
  color: #424242;
  float: left;
  font-family: 'Roboto', sans-serif;
  margin-left: 5px;
`;
